<div class="fhlb-font-color-2 help-tip margin-right-minus-5px">
    <ng-template #popContent><div [innerHTML]="toolTipText"></div></ng-template>
    <div id="help-tip-common" [ngbPopover]="popContent" placement="top-right" [autoClose]="false"
    triggers="mouseenter:mouseleave" popoverClass="popoverBG">
        <span class="fa fa-2x fa-question-circle font-color-dark-orange"></span>
    </div>
    <div class="margin-top-minus-10px text-center">
        <span class="inline-help-text">HELP</span>
    </div>
</div>